import React from 'react';
import PropTypes from 'prop-types';

import { WindowProxy } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

const CategoryGroupButton = ({ isActive, url, label }) => {
    const handleClick = () =>
        AnalyticsService.ga4Trigger(TAGS.LAYER_NAVIGATION__FILTERS(WindowProxy.location().pathname, 'condition'));

    return (
        <p className={isActive && 'current-filter'} onClick={handleClick}>
            <a href={url}>{label}</a>
        </p>
    );
};

CategoryGroupButton.propTypes = {
    isActive: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

CategoryGroupButton.displayName = 'CategoryGroupButton';

export default CategoryGroupButton;
